var data = [
  {
    path: "/xitongkaidan",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/components/xiyang/dingdan/xitongkaidanNew"),
  },
  {
    path: "/gnyskaidan",
    meta: {
      keepAlive: true,
    },
    component: () => import("@/components/xiyang/dingdan/xitongkaidanGnNew"),
  },
  {
    path: "/carAccessApply",
    component: () => import("@/components/xiyang/carAccessApply/index"),
  },
  {
    path: "/czkdtj",
    component: () => import("@/components/xiyang/dingdan/kaidanTongji"),
  },
  {
    path: "/dingdanmuban",
    component: () => import("@/components/xiyang/dingdan/feiyongMuban"),
  },
  {
    path: "/rwdlb",
    component: () => import("@/components/xiyang/diaodu/renwudan"),
  },
  {
    path: "/rwdlbLYGn",
    component: () => import("@/components/xiyang/diaodu/renwudanGn"),
  },
  {
    path: "/rwdlbLY",
    component: () => import("@/components/xiyang/diaodu/renwudan"),
  },
  {
    path: "/pcbFL",
    name: "中港排车调度",
    component: () => import("@/components/xiyang/diaodu/paiCheBiao"),
  },
  {
    path: "/pcbFLV2",
    component: () => import("@/components/xiyang/diaodu/paiCheBiao2"),
  },
  {
    path: "/gnpcbFL",
    name: "国内排车调度",
    component: () => import("@/components/xiyang/diaodu/paiCheBiaoGn"),
  },
  {
    path: "/changeRecord",
    component: () => import("@/components/xiyang/report/paySign"),
  },
  {
    path: "/gnpcbFLV2",
    name: "国内排车调度",
    component: () => import("@/components/xiyang/diaodu/paiCheBiaoGn2"),
  },
  {
    path: "/ypzcx",
    component: () => import("@/components/xiyang/diaodu/paiCheBiaoYpc"),
  },
  {
    path: "/pcdlb",
    component: () => import("@/components/xiyang/diaodu/paiCheDan"),
  },
  {
    path: "/pcdlbGn",
    component: () => import("@/components/xiyang/diaodu/paiCheDanGn"),
  },
  {
    path: "/sjccjl",
    component: () => import("@/components/xiyang/diaodu/chuchejilu"),
  },
  {
    path: "/yunshushijian",
    component: () => import("@/components/xiyang/diaodu/yunshushijian"),
  },
  {
    path: "/xiaoshoudingdan",
    component: () => import("@/components/xiyang/xiaoshou/xiaoshoudingdan"),
  },
  {
    path: "/exportTemplet",
    component: () => import("@/components/xiyang/xiaoshou/taitou"),
  },
  {
    path: "/wlkehuguanli",
    component: () => import("@/components/xiyang/kehu/index"),
  },
  {
    path: "/wlkehuguanliBlack",
    component: () => import("@/components/xiyang/kehu/indexhmd.vue"),
  },
  {
    path: "/ownerBlack",
    component: () => import("@/components/xiyang/hezuoshang/indexhmd.vue"),
  },
  {
    path: "/wlgongyingshangguanli",
    component: () => import("@/components/xiyang/hezuoshang/index"),
  },
  {
    path: "/commonRate",
    component: () => import("@/components/xiyang/kehu/huilvgongyong"),
  },
  {
    path: "/customerRate",
    component: () => import("@/components/xiyang/kehu/huilvsiyou"),
  },
  {
    path: "/supplierRate",
    component: () => import("@/components/xiyang/hezuoshang/huilvsiyou"),
  },
  {
    path: "/fkApply",
    component: () => import("@/components/xiyang/caiwuBaoxiao/fukuanshenqing"),
  },
  {
    path: "/flowConfig",
    component: () => import("@/components/xiyang/caiwuBaoxiao/liuchengpeizhi"),
  },
  {
    path: "/bxApply",
    component: () => import("@/components/xiyang/caiwuBaoxiao/baoxiaoshenqing"),
  },
  {
    path: "/costFlowPending",
    component: () => import("@/components/xiyang/caiwuBaoxiao/daibanshenpi"),
  },
  {
    path: "/costFlowHistory",
    component: () => import("@/components/xiyang/caiwuBaoxiao/yibanchaxun"),
  },
  {
    path: "/payableCost",
    component: () => import("@/components/xiyang/caiwuGuanli/yingFu"),
  },
  {
    path: "/receivableCost",
    component: () => import("@/components/xiyang/caiwuGuanli/yingShou.vue"),
  },
  {
    path: "/formDriverCost",
    component: () => import("@/components/xiyang/sijiFeiyong/luru"),
  },
  {
    path: "/duizhangguanli",
    component: () => import("@/components/xiyang/sijiFeiyong/duizhangdan"),
  },
  /* {
    path: "/yysdzd",
    component: () => import("@/components/xiyang/caiwuGuanli/yingshouDuiZhang")
  }, */
  /* {
    path: "/yyfdzd",
    component: () => import("@/components/xiyang/caiwuGuanli/yingfuDuizhang.vue")
  }, */
  {
    path: "/ysktj",
    component: () => import("@/components/xiyang/caiwuGuanli/yueShoukuan"),
  },
  {
    path: "/yfktj",
    component: () => import("@/components/xiyang/caiwuGuanli/yueFukuan"),
  },
  {
    path: "/tallyBook",
    component: () => import("@/components/xiyang/caiwuGuanli/jizhangShouzhi"),
  },
  {
    path: "/tallyAccount",
    component: () => import("@/components/xiyang/caiwuGuanli/taiZhang"),
  },
  {
    path: "/tallyBookPay",
    component: () => import("@/components/xiyang/caiwuGuanli/zhangHuZhiChu"),
  },
  {
    path: "/tallyBookReceivable",
    component: () => import("@/components/xiyang/caiwuGuanli/zhangHuShouRu"),
  },
  {
    path: "/yyfhxd",
    component: () =>
      import("@/components/xiyang/caiwuGuanli/yingfuDuizhangdan.vue"),
  },
  {
    path: "/yyshxd",
    component: () =>
      import("@/components/xiyang/caiwuGuanli/yingshouDuizhangdan.vue"),
  },
  {
    path: "/payableCostYY",
    component: () => import("@/components/xiyang/caiwuGuanli/yingfuYunYing"),
  },
  {
    path: "/yszk",
    component: () =>
      import("@/components/xiyang/caiwuGuanli/yingshouZhangkuan"),
  },
  {
    path: "/yfzk",
    component: () => import("@/components/xiyang/caiwuGuanli/yingfuZhangkuan"),
  },
  {
    path: "/hxd",
    component: () => import("@/components/xiyang/caiwuGuanli/hexiaodan"),
  },
  {
    path: "/receivableCostYY",
    component: () => import("@/components/xiyang/caiwuGuanli/yingShouYunYing"),
  },
  {
    path: "/fmsExportTmpl",
    component: () => import("@/components/xiyang/caiwuGuanli/mubanGuanli"),
  },
  {
    path: "//danhaopeizhi",
    component: () => import("@/components/xiyang/dingdan/danhaopeizhi"),
  },
  {
    path: "/lsjb",
    component: () => import("@/components/xiyang/dingdan/hisOrdes"),
  },
  {
    path: "/khfytj",
    component: () => import("@/components/xiyang/caiwuTongji/kehuTongji"),
  },
  {
    path: "/khlrtj",
    component: () => import("@/components/xiyang/caiwuTongji/kehuHuizong"),
  },
  {
    path: "/ywlrtj",
    component: () => import("@/components/xiyang/caiwuTongji/yewuyuanHuizong"),
  },

  {
    path: "/dealingsSituationList",
    name: "往来情况查询",
    component: () =>
      import("@/components/xiyang/caiwuTongji/dealingsSituationList"),
  },
  {
    path: "/bjrlrtj",
    name: "报价人利润费用统计",
    component: () => import("@/components/xiyang/caiwuTongji/bjrlrtj"),
  },
  {
    path: "/jygl",
    component: () => import("@/components/xiyang/pay/jiayou"),
  },
  {
    path: "/weixiu",
    component: () => import("@/components/xiyang/pay/weixiu"),
  },
  {
    path: "/baoyangCost",
    component: () => import("@/components/xiyang/pay/baoyang.vue"),
  },
  {
    path: "/wash",
    component: () => import("@/components/xiyang/pay/wash"),
  },

  {
    path: "/cprk",
    component: () => import("@/components/xiyang/cangku/ruKu"),
  },
  {
    path: "/cpck",
    component: () => import("@/components/xiyang/cangku/chuKu"),
  },
  {
    path: "/etcCost",
    component: () => import("@/components/xiyang/pay/etc"),
  },
  {
    path: "/xitongkaidanSaleman",
    component: () => import("@/components/xiyang/dingdan/xitongkaidanRead"),
  },
  {
    path: "/receivableCostSaleman",
    component: () => import("@/components/xiyang/caiwuGuanli/yingShouRead"),
  },
  {
    path: "/khlrtjSaleman",
    component: () => import("@/components/xiyang/caiwuTongji/kehuHuizongRead"),
  },
  {
    path: "/hzsfytj",
    component: () =>
      import("@/components/xiyang/caiwuTongji/heZuoShangHuizong"),
  },
  {
    path: "/kehubaojia",
    component: () => import("@/components/xiyang/baojia/kehubaojia"),
  },
  {
    path: "/ysyf/list",
    component: () => import("@/components/xiyang/report/yingshouYingfu"),
  },
  {
    path: "/ysyf/ys",
    component: () => import("@/components/xiyang/report/yingshou"),
  },
  {
    path: "/ysyf/yf",
    component: () => import("@/components/xiyang/report/Yingfu"),
  },
  {
    path: "/report/costStatistics/list",
    component: () => import("@/components/xiyang/report/feiyongTongji"),
  },
  {
    path: "/supplier/profit/list",
    component: () => import("@/components/xiyang/report/gongyingshangLirun"),
  },
  {
    path: "/holdDay",
    component: () => import("@/components/xiyang/report/jieJiaRi"),
  },
];
export default data;



// WEBPACK FOOTER //
// ./src/router/xiyang.js